import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Company {
  id: string
  name: string
  invoice_prefix: string
  gst_number?: string
  state_code?: string
}

interface CompanyStore {
  activeCompanyId: string | null
  activeCompany: Company | null
  setActiveCompany: (company: Company) => void
  clearActiveCompany: () => void
}

export const useCompanyStore = create<CompanyStore>()(
  persist(
    (set) => ({
      activeCompanyId: null,
      activeCompany: null,
      setActiveCompany: (company) =>
        set({ activeCompanyId: company.id, activeCompany: company }),
      clearActiveCompany: () =>
        set({ activeCompanyId: null, activeCompany: null }),
    }),
    {
      name: 'finops-active-company',
    }
  )
)
